import React from 'react';
import {
    ArrayInput,
    Create,
    CreateButton,
    Datagrid,
    Edit,
    EditButton,
    Filter,
    List,
    SimpleForm,
    SimpleFormIterator,
    TextField,
    TextInput,
    translate,
} from 'react-admin';
import BookmarkIcon from '@material-ui/icons/Bookmark';
import Toolbar from '@material-ui/core/Toolbar';

import CompanySelect from '../../../../components/CompanySelect';
import productGroup from '../productGroup';
import resourceLocales from './locales';
import resourceConfig from './config';
import exporter from '../../../../utils/exporter';
import PostPagination from '../../../../utils/pagination';

const ResourceIcon = BookmarkIcon;

const ResourceListFilter = (props) => (
    <Filter {...props}>
        <TextInput source={'companyName'} />
        <TextInput source={'productGroup'} />
        <TextInput source={'kpp'} />
    </Filter>
);

const ResourceListActions = ({
    bulkActions,
    basePath,
    displayedFilters,
    filters,
    filterValues,
    onUnselectItems,
    resource,
    selectedIds,
    showFilter,
}) => (
    <Toolbar>
        {bulkActions &&
            React.cloneElement(bulkActions, {
                basePath,
                filterValues,
                resource,
                selectedIds,
                onUnselectItems,
            })}
        {filters &&
            React.cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
        <CreateButton basePath={basePath} />
    </Toolbar>
);

const ResourceList = (props) => (
    <List
        {...props}
        actions={<ResourceListActions />}
        filters={<ResourceListFilter />}
        sort={{ field: 'id', order: 'DESC' }}
        exporter={exporter}
        pagination={<PostPagination />}
    >
        <Datagrid>
            <TextField source={'id'} />
            <TextField source={'companyName'} />
            <TextField source={'productGroup'} />
            <EditButton />
        </Datagrid>
    </List>
);

const ResourceTitle = translate(({ record, translate }) => (
    <span>
        {translate(`resources.${resourceConfig.name}.name`, { smart_count: 1 })} &quot;{record.id}&quot;
    </span>
));

const ResourceCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
            <CompanySelect source={'companyName'} optionValue={'name'} />
            <productGroup.Input source={'productGroup'} />
            <ArrayInput source={'items'}>
                <SimpleFormIterator>
                    <TextInput source={'fiasId'} />
                    <TextInput source={'kpp'} />
                </SimpleFormIterator>
            </ArrayInput>
        </SimpleForm>
    </Create>
);

const ResourceEdit = (props) => (
    <Edit redirect={null} undoable={false} title={<ResourceTitle />} {...props}>
        <SimpleForm redirect={false}>
            <TextField source={'id'} />
            <CompanySelect source={'companyName'} optionValue={'name'} />
            <productGroup.Input source={'productGroup'} />
            <ArrayInput source={'items'}>
                <SimpleFormIterator>
                    <TextInput source={'fiasId'} />
                    <TextInput source={'kpp'} />
                </SimpleFormIterator>
            </ArrayInput>
        </SimpleForm>
    </Edit>
);

export default {
    Icon: ResourceIcon,
    List: ResourceList,
    Title: ResourceTitle,
    Create: ResourceCreate,
    Edit: ResourceEdit,

    name: resourceConfig.name,
    resourceConfig: {
        name: resourceConfig.name,
        list: ResourceList,
        edit: ResourceEdit,
        create: ResourceCreate,
        icon: ResourceIcon,
    },
    menuConfig: {
        name: resourceConfig.name,
        icon: ResourceIcon,
    },
    locales: resourceLocales,
    restProviderResolve: {
        name: resourceConfig.name,
        apiService: resourceConfig.apiService,
        basePath: resourceConfig.apiPath,
        schema: {},
    },
};